import React from "react"
export function DownChevronOutline(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14zm3.506 4.687l.988 1.13-4 3.5a.75.75 0 01-.9.066l-.088-.067-4-3.5.988-1.129 3.505 3.068 3.507-3.068z"
        fill="currentColor"
        fillRule="nonzero"
        id="prefix__down-chevron---outline"
        stroke="none"
        strokeWidth={1}
      />
    </svg>
  )
}
